
import { Reducer } from 'redux';
import { STATE } from 'app/constants';
import { mergeReducers } from 'app/infrastructure/redux/merge-reducers';
import { withOptionsReducer } from 'app/components/options-handler';
import { DashboardAdminState } from './types-store';
import { reducer as dashboardAdminFormReducer, INITIAL_STATE as dashboardAdminFormState } from './form/reducers';
import { reducer as dashboardAdminListReducer, INITIAL_STATE as dashboardAdminListState } from './list/reducers';
import { reducer as dashboardSavedReportsReducer, INITIAL_STATE as dashboardSavedReportsState } from './saved-reports/reducers';

export const INITIAL_STATE: DashboardAdminState = {
  form: dashboardAdminFormState,
  list: dashboardAdminListState,
  savedReports: dashboardSavedReportsState
};

export const reducer: Reducer<DashboardAdminState> = withOptionsReducer(
  STATE.dashboardAdministration,
  mergeReducers({
    form: dashboardAdminFormReducer,
    list: dashboardAdminListReducer,
    savedReports: dashboardSavedReportsReducer
  })
);
